import React from "react";
import { Branding } from "../Header/Header";

import "../App.scss";

function InvalidURL() {
  return (
    <div className="grid-container invalid-url">
      <header className="header">
        <Branding />
      </header>

      <main className="tracker">
        <div className="invalid-message">
          <h2>Oops...</h2>

          <h3>Not a valid URL</h3>
        </div>
      </main>
    </div>
  );
}

export default InvalidURL;
